import { render, staticRenderFns } from "./contractTerminationAdd.vue?vue&type=template&id=06f25cac&scoped=true"
import script from "./contractTerminationAdd.vue?vue&type=script&lang=js"
export * from "./contractTerminationAdd.vue?vue&type=script&lang=js"
import style0 from "./contractTerminationAdd.vue?vue&type=style&index=0&id=06f25cac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f25cac",
  null
  
)

export default component.exports